import { useContext } from "react";
import { FindAStoreContext } from "../contexts/findAStore";

const NoResults = () => {
  const {
    state: { place },
  } = useContext(FindAStoreContext);

  return (
    <div
      sx={{
        marginLeft: ["20px", null, null, "100px"],
        marginRight: ["20px", null, null, "100px"],
        textAlign: "center",
      }}
    >
      <h2
        sx={{
          color: "#00502f",
          fontSize: "24px",
          margin: "10px 0 20px 0",
        }}
      >
        {"We're sorry! We were unable to locate any stores within a 50 mile radius of your " +
          place?.source +
          "."}
      </h2>

      <p
        sx={{
          fontSize: "1rem",
        }}
      >
        Need a cash loan? You can apply online and get cash sent straight to
        your checking account.
      </p>
      <div
        sx={{
          marginTop: "20px",
        }}
      >
        <a href="/secure/LoanApplication">
          <button
            sx={{
              variant: "buttons.apply",
              fontSize: "15px",
              padding: "0.5rem 1.25rem",
              fontWeight: "bold",
              letterSpacing: "1.25px",
              textTransform: "uppercase",
            }}
          >
            Apply Now
          </button>
        </a>
      </div>
    </div>
  );
};

export default NoResults;
